<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="用户id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input type="text" v-decorator="['userId']" disabled="disabled" />
        </a-form-item>
        <a-form-item
          label="兑换奖品id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input type="text" v-decorator="['prizesId']" disabled="disabled" />
        </a-form-item>
        <a-form-item
          label="兑换奖品名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            v-decorator="['prizesName']"
            disabled="disabled"
          />
        </a-form-item>
        <a-form-item
          label="奖品价值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['prizesValue']" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['prizesSource']" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item
          label="兑奖状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="['status']"
            disabled="disabled"
            :triggerChange="true"
            dictCode="exchange_prizes_type"
          />
        </a-form-item>
        <a-form-item
          label="兑奖人电话"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input type="text" v-decorator="['phone']" disabled="disabled" />
        </a-form-item>
        <a-form-item
          label="兑奖人名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['userName']" disabled="disabled" />
        </a-form-item>
        <a-form-item
          label="邮寄地址"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['address']" disabled="disabled"></a-input>
        </a-form-item>
        <a-form-item
          label="快递单号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input v-decorator="['trackingNumber']"></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import JImageUpload from '@/components/jeecg/JImageUpload';
// import { getAction } from '../../../../api/manage';

export default {
  name: 'MarketExchangePrizesModal',
  components: {
    JDate,
    JImageUpload,
  },
  data() {
    return {
      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        edit:
          process.env.VUE_APP_CMS_MARKETING + '/market/exchange/prizes/edit',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);

      if (this.model.prizesSource === '1') {
        this.model.prizesSource = '奖品库';
      } else if (this.model.prizesSource === '2') {
        this.model.prizesSource = '积分库';
      }

      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'userId',
            'prizesId',
            'prizesName',
            'prizesValue',
            'prizesSource',
            'status',
            'phone',
            'userName',
            'address',
            'trackingNumber'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'put';
          }

          let formData = Object.assign(this.model, values);
          formData.prizesSource =
            formData.prizesSource === '奖品库' ? '1' : '2';
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'userId',
          'prizesId',
          'prizesName',
          'prizesValue',
          'prizesSource',
          'status',
          'phone',
          'userName',
          'address',
          'trackingNumber'
        )
      );
    },
    receiveTypesValue(e) {},
  },
};
</script>
